import { useCallback } from 'react';
import moment from 'moment-timezone';
import styled from 'styled-components';
import { colors } from '@karnott/colors';
import { TimeIcon } from '@karnott/icons';
import { ImplementPopup } from '@karnott/map';
import { fontFamily, pixelSpacing } from '@karnott/theme';
import { KARNOTT_LINKS } from '../../../../constants/links';
import { ANALYTICS, sendAnalyticsTooltipClickEvent } from '../../../../utils/AnalyticsConstants';

const EquipmentTooltipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2px;
  font-family: ${fontFamily()};
  color: ${colors('black', 600)};
`;

const EquipmentTooltipRow = styled.div`
  display: flex;
  flex-direction: 'row';
  align-items: center;
  gap: ${pixelSpacing('xSmall')};
`;

export function EquipmentTooltip({ equipmentProps, labels }) {
  const {
    Icon,
    name,
    isActive,
    type,
    cluster,
    lastDate,
    deviceType,
    deviceName,
    deviceBattery,
    batteryCharging,
    equipmentId,
    healthIssue,
    history,
  } = equipmentProps;

  const actionCB = useCallback(() => {
    sendAnalyticsTooltipClickEvent(window)(ANALYTICS.LABEL.TOOLTIPS.EQUIPMENT);
    history.push(`/equipments/${equipmentId}/`);
  }, [history, equipmentId]);

  const openDiag = useCallback(() => {
    sendAnalyticsTooltipClickEvent(window)(ANALYTICS.LABEL.TOOLTIPS.DIAGNOSE);
    window.open(KARNOTT_LINKS.DIAGNOSE_FORM, '_blank', 'noopener noreferrer');
  }, []);

  return (
    <ImplementPopup
      Icon={Icon}
      implementLabel={name}
      isActive={isActive}
      implementType={type}
      clusterName={cluster}
      lastDate={lastDate}
      deviceType={deviceType}
      deviceLabel={deviceName}
      warning={healthIssue}
      deviceBattery={deviceBattery}
      batteryCharging={batteryCharging}
      chipAction={actionCB}
      labels={labels}
      diagnoseAction={openDiag}
    />
  );
}

export function EquipmentSessionPointTooltip({ point }) {
  return (
    <EquipmentTooltipWrapper>
      <EquipmentTooltipRow>
        <TimeIcon size={12} color="currentColor" />
        <span>{moment(point.location_date).format('HH:mm')}</span>
      </EquipmentTooltipRow>
    </EquipmentTooltipWrapper>
  );
}
